/**
 * Remembers a page's filter choices in localStorage so they survive navigating away and reloads.
 * Storage can be unavailable or hold stale data, so every access is guarded and values are validated.
 */
export function loadSavedState<T extends object>(key: string, defaults: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return { ...defaults };
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return { ...defaults };
    // Keep only known keys whose type matches the default, so old or tampered data cannot break the page
    const result: any = { ...defaults };
    for (const k of Object.keys(defaults) as Array<keyof T>) {
      if (typeof parsed[k] === typeof defaults[k]) result[k] = parsed[k];
    }
    return result as T;
  } catch {
    return { ...defaults };
  }
}

export function saveState(key: string, state: object): void {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch {
    // Storage full or blocked: the filters just will not be remembered
  }
}
